import React, { useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from '../context/AuthContext';
import "./ChangePasswordModal.css";
import CloseIcon from "@mui/icons-material/Close";
import { getChangePwdUrl } from '../constants';

const ChangePasswordModal = ({ isOpen, onClose, onSuccess }) => {
  const { userid, token } = useContext(AuthContext);
  const [oldPassword, setOldPassword] = useState(""); // New state for old password
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const validatePassword = (pwd) => {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(pwd);
  };

  const handleSubmit = async () => {
    if (!oldPassword) {
        setError("Please enter your old password.");
        return;
    }
    if (!validatePassword(password)) {
        setError("Password must be at least 8 characters long and include an uppercase letter, a number, and a special character.");
        return;
    }
    if (password !== confirmPassword) {
        setError("Passwords do not match.");
        return;
    }

    setError("");
    setLoading(true);

    try {
        const response = await axios.post(
            getChangePwdUrl(), // API URL
            { userid, oldPassword, newPassword: password }, // Request Body
            { 
                headers: {
                    Authorization: `Bearer ${token}`, // Pass token here
                    "Content-Type": "application/json",
                },
            }
        );

        onSuccess(response.data.message || "Password changed successfully!");
        onClose(); // Close modal after success

    } catch (err) {
        console.log(err);
        setError(err.response?.data?.message || "Failed to change password. Please try again.");
    } finally {
        setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="cm-modal-overlay">
      <div className="cm-modal-box">
        <button className="cm-close-button" onClick={onClose}>
          <CloseIcon />
        </button>

        <h2>Change Password</h2>

        {/* Old Password Input */}
        <div className="fp-password-wrapper">
          <input
            type={showOldPassword ? "text" : "password"}
            placeholder="Old Password"
            className="cm-input-field"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
          />
          <span
            className="fp-eye-icon"
            onClick={() => setShowOldPassword(!showOldPassword)}
          >
            {showOldPassword ? "👁️" : "🙈"}
          </span>
        </div>

        {/* New Password Input */}
        <div className="fp-password-wrapper">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="New Password"
            className="cm-input-field"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <span
            className="fp-eye-icon"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? "👁️" : "🙈"}
          </span>
        </div>

        {/* Confirm Password Input */}
        <div className="fp-password-wrapper">
          <input
            type={showConfirmPassword ? "text" : "password"}
            placeholder="Confirm Password"
            className="cm-input-field"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <span
            className="fp-eye-icon"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            {showConfirmPassword ? "👁️" : "🙈"}
          </span>
        </div>

        {error && <p className="cm-error-text">{error}</p>}

        <button className="cm-submit-button" onClick={handleSubmit} disabled={loading}>
          {loading ? "Changing..." : "Change Password"}
        </button>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
